import { render, staticRenderFns } from "./YesterdayLevel1.vue?vue&type=template&id=43d34854&scoped=true"
import script from "./YesterdayLevel1.vue?vue&type=script&lang=js"
export * from "./YesterdayLevel1.vue?vue&type=script&lang=js"
import style0 from "./YesterdayLevel1.vue?vue&type=style&index=0&id=43d34854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d34854",
  null
  
)

export default component.exports